import ObjectId from 'bson-objectid';
import isArray from 'lodash/isArray';

import Types from '../../modules/types';

import { renderCurrency } from '../../components/SystemCountry';

import tests from '../../helpers/tests';

const {
  CONSTANTS: {
    StoreType,
  },
} = Types;

const {
  viewerIsSellerMerchant,
  viewerIsSellerReferral,
} = tests;

// const activityNotEdit = props => props && props.activity !== 'edit';
const activityNotCreate = props => props && props.activity !== 'create';

export const fieldName = ['FieldText', {
  name: 'name',
  rules: [['validation.isRequired']],
  disabled: [viewerIsSellerReferral],
}];

export const fieldStore = ['FieldConnectionSelect', {
  name: 'store',
  label: 'Store',
  placeholder: 'Select the owner store',
  url: '/stores/list',
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  skip: [viewerIsSellerMerchant],
  disabled: [activityNotCreate],
  virtual: [activityNotCreate],
  getExtraQueryConditions: () => [{ type: StoreType.MERCHANT }],
}];

export const fieldReferralStore = ['FieldConnectionSelect', {
  name: 'referralStore',
  label: 'Referral Store',
  placeholder: 'Select the referral store',
  url: '/stores',
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  skip: [viewerIsSellerReferral],
  disabled: [activityNotCreate],
  virtual: [activityNotCreate],
  getExtraQueryConditions: () => [{ type: StoreType.REFERRAL }],
}];

export const [
  fieldDiscount,
  fieldRevenue,
] = [
  ['discount', 'Customer Discount', 'Discount'],
  ['revenue', 'Partner Revenue', 'Revenue'],
].map(([name, label, columnSuffix = '']) => ['FieldTable', {
  name,
  label,
  disabled: [viewerIsSellerReferral],
  virtual: [viewerIsSellerReferral],
  rules: [['validation.isRequired']],
  table: {
    showHeader: true,
    scroll: { x: '520px' },
  },
  controlsEnabled: true,
  controlsGetNewItem: () => ({
    _id: `${ObjectId()}`,
  }),
  prepareValueForInput: (value, props) => (
      !isArray(value) || !value.length
    ? [props.controlsGetNewItem()]
    : value
  ),
  columns: [{
    key: 'threshold',
    title: 'Minimum Items Price',
    fields: [{
      name: 'threshold',
      props: {
        size: 'small',
        align: 'right',
        placeholder: 'Minimum price',
        addonBefore: renderCurrency(),
      },
    }],
  }, {
    ket: 'fixed',
    title: `Fixed ${columnSuffix}`,
    fields: [{
      name: 'fixed',
      props: {
        size: 'small',
        align: 'right',
        placeholder: 'Fixed',
        addonBefore: renderCurrency(),
      },
    }],
  }, {
    ket: 'percentage',
    title: `Percentage ${columnSuffix}`,
    fields: [{
      name: 'percentage',
      props: {
        size: 'small',
        align: 'right',
        placeholder: 'Percentage',
        addonBefore: '%',
      },
    }],
  }],
}]);

// export const fieldDiscountOld = ['FieldText', {
//   name: 'discount.value',
//   label: 'Discount',
//   initialValue: 0,
//   placeholder: 'eg. 20%',
//   addonAfter: '%',
//   type: 'number',
//   rules: [
//     ['validation.isRequired'],
//     ['validation.isNumber'],
//   ],
//   disabled: [viewerIsSellerReferral],
// }];

// export const fieldRevenueOld = ['FieldText', {
//   name: 'revenue.value',
//   label: 'Revenue',
//   initialValue: 0,
//   placeholder: 'eg. 5%',
//   addonAfter: '%',
//   type: 'number',
//   rules: [
//     ['validation.isRequired'],
//     ['validation.isNumber'],
//   ],
//   disabled: [viewerIsSellerReferral],
// }];

export const ADMIN = [
  fieldName,
  fieldStore,
  fieldReferralStore,
  fieldDiscount,
  fieldRevenue,
];

export const SELLER = [
  fieldName,
  fieldStore,
  fieldReferralStore,
  fieldDiscount,
  fieldRevenue,
];
